<div class="it-pane">
	<div class="it-panehead">
		<div class="it-panehead-left">
			<span class="it-smalllabel">Headers</span>
			<span class="it-badge">Auto: <code>X-Al-ApplicationId</code> / <code>X-Al-LoginId</code></span>
		</div>
		<div class="it-panehead-right">
			<button class="it-toolbtn" type="button" (click)="add.emit()">Add</button>
			<button class="it-toolbtn" type="button" (click)="addCommon.emit()">Common</button>
			<button class="it-toolbtn" type="button" (click)="clear.emit()" [disabled]="request.headers.length===0">Clear</button>
		</div>
	</div>

	<it-kv-editor [rows]="request.headers" (updateKv)="updateKv.emit($event)" (remove)="remove.emit($event)">
	</it-kv-editor>

	<div class="it-empty" *ngIf="request.headers.length===0">No headers.</div>
</div>
